// import {createI18n} from 'vue-i18n';

let VueI18n;

// console.log("当前环境变量 VUE_APP_ENV:", process.env.VUE_APP_ENV);  // 输出环境变量值，帮助调试

if (process.env.VUE_APP_ENV === 'development') {
    console.log("获取本地 vue-i18n");
    VueI18n = require('vue-i18n');
    globalThis.VueI18n = VueI18n;  // 将 VueI18n 设为全局变量，供其他模块使用
} else {
    // console.log("获取 cdn vue-i18n");
    VueI18n = window.VueI18n;  // 从全局对象中获取 VueI18n，CDN 已加载到页面中
}

const { createI18n } = VueI18n;


import en from './locales/en.json';
import cn from './locales/cn.json';
import br from './locales/br.json';
import de from './locales/de.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import jp from './locales/jp.json';
import ko from './locales/ko.json';
import ru from './locales/ru.json';

const messages = {
  en,
  cn,
  br,
  de,
  es,
  fr,
  it,
  jp,
  ko,
  ru
};

const i18n = createI18n({
  locale: 'en', // 设置默认语言
  fallbackLocale: 'en', // 设置回退语言
  messages
});

export default i18n;